/**
 * This directive marks form as invalid if none of provided expressions is set (has truthy value as $modelValue).
 *
 * Usage:
 * <form>
 *  <div rw-required-one-of="[ctrl.first, ctrl.second]">
 *    <input type="checkbox" ng-model="ctrl.first">
 *    <input type="checkbox" ng-model="ctrl.second">
 *  </div>
 * </form>
 */

const defaultErrorKey = 'rwRequiredOneOf';

export default function rwRequiredOneOfDirective() {
  return {
    require: ['^form'],
    link: (scope, element, attrs, [ngForm]) => {
      scope.$watch(attrs.rwRequiredOneOf, (values = []) => {
        const isValid = values.some((value) => value);
        ngForm.$setValidity(attrs.rwRequiredOneOfErrorKey || defaultErrorKey, isValid, ngForm);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-required-one-of/rw-required-one-of-directive.js